import { settings } from '../../../settings/settings-util'
import reducer from './reducers/index';
import Initialization from './handlers/initialization';
import ResponseHandler from './handlers/notifications-response';
import GetNotifications from './handlers/get-notifications';

export default class AlmeNotificationsApi {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._responseHandler = new ResponseHandler(this._settings);
        this._initialization = new Initialization(this._settings);
        this._notifications = new GetNotifications(this._settings);
    }

    static getDefaultSettings() {
        return settings;
    }
    
    initialize(store) {
        this._store = store;
        this._notifications.initialize(store);
        this._responseHandler.initialize(store, this._notifications);
        this._initialization.initialize(store, this._notifications);
    }

    getReducer() {
        return reducer;
    }

    getResponseHandler() {
        return this._responseHandler;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/alme-notificationsapi.js